import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface DeleteWaitListParams {
  waitlistId: string;
  classId: string;
}

export const deleteWaitListAPI = async (params: DeleteWaitListParams) => {
  const response = await baseAPI.delete<unknown>(
    `/waitlist/${params.waitlistId}`,
  );
  return response.data;
};

export const useDeleteWaitList = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: DeleteWaitListParams) => deleteWaitListAPI(params),
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WAIT_LIST_SUMMARY, params.classId],
      });
    },
  });
};
